import React, { useEffect } from "react"
import PropTypes from "prop-types"
import ls from "@livesession/sdk"
import GlobalStyle from "../../styles/GlobalStyles"
import Navigation from "./Navigation"
import Footer from "./Footer"

const Layout = ({ children, blackNav, hideInstaPosts, hideFooter }) => {
  useEffect(() => {
    ls.init("c944514e.69d00e24")
    ls.newPageView()
  }, [])
  return (
    <>
      <GlobalStyle />
      <Navigation blackNav={blackNav} />
      {children}
      {!hideFooter && <Footer hideInstaPosts={hideInstaPosts} />}
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  blackNav: PropTypes.bool,
  hideInstaPosts: PropTypes.bool,
  hideFooter: PropTypes.bool,
}

Layout.defaultProps = {
  blackNav: false,
  hideInstaPosts: false,
  hideFooter: false,
}
export default Layout
